import { HelpIcon as HelpIconDs, Typography } from "@packages/ds";
import styled, { css } from "styled-components";

import * as Table from "ds/Table";

export const Section = styled.section`
  width: 100%;
`;

export const Title = styled(Typography.Title)`
  margin-bottom: 16px;
`;

export const InfoTextWrapper = styled.div`
  display: flex;
  align-items: center;
  margin: 16px 0 18px 0;
  color: var(--slate);
`;

export const HelpIcon = styled(HelpIconDs)`
  margin-right: 8px;
`;

export const ToolTipWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

const tableStyles = css`
  display: grid;
  grid-template-columns: 32% 40% 20% 8%;
  @media (max-width: 1080px) {
    grid-template-columns: 2fr 3fr 2fr 60px;
  }
`;

export const TableThead = styled(Table.Thead)`
  ${tableStyles}
`;

export const TableTr = styled(Table.Tr)`
  ${tableStyles}
`;

export const TableTd = styled(Table.Td)`
  text-transform: capitalize;
`;
